import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from 'react';
import Link from 'syf-component-library/ui/atoms/Link';
import getLanguageFromStorage from 'syf-js-utilities/helpers/getLanguageFromStorage';
import { DATA_ANALYTICS, DATA_TYPE } from '../../const/analytics';
import MainContext from '../../Context';
import { isMonthly, isPN4, isSecuredInstallmentLoanProduct, isSetpayLegacyProduct } from '../../helpers';
import isDCHCustomerAssistancePlanEnrolled from '../../helpers/isDCHCustomerAssistancePlanEnrolled';
import { t } from '../../strings/i18n';
const getTermsAndConditionsLink = (billing, staticHostName, currentLanguage, productType, featureFlags) => {
    if (isDCHCustomerAssistancePlanEnrolled(billing, productType, featureFlags))
        return `${staticHostName}/makeapayment/cap/${currentLanguage}/autopay_authorization.pdf`;
    if (isSetpayLegacyProduct(productType))
        return `${staticHostName}/makeapayment/setpay/${currentLanguage}/autopay_authorization.pdf`;
    if (isMonthly(productType))
        return `${staticHostName}/makeapayment/setpay/${currentLanguage}/EnterpriseMonthlyAutopayTerms.pdf`;
    if (isPN4(productType))
        return `${staticHostName}/makeapayment/setpay/${currentLanguage}/BNPLInstallmentContractOnline.pdf`;
    if (isSecuredInstallmentLoanProduct(productType))
        return `${staticHostName}/makeapayment/si/${currentLanguage}/AutopayTerms.pdf`;
    return `${staticHostName}/makeapayment/rc/${currentLanguage}/autopay_authorization.pdf`;
};
const ClickHereLink = ({ product, billing, featureFlags, children }) => {
    const { staticHostName } = useContext(MainContext);
    const currentLanguage = getLanguageFromStorage();
    const termsAndConditionsLink = getTermsAndConditionsLink(billing, staticHostName, currentLanguage, product.type, featureFlags);
    return (_jsx(Link, Object.assign({ className: "ensightencustomevent", "data-analytics": DATA_ANALYTICS.CLICK_TRACKING_EVENT, "data-cy": "autopay-term-conditions-link", "data-object": "link", "data-reason": "click here", "data-type": DATA_TYPE.MAKE_A_PAYMENT, href: termsAndConditionsLink, isInline: true, rel: "noopener noreferrer", target: "_blank" }, { children: children !== null && children !== void 0 ? children : t('button.clickHere') })));
};
export default ClickHereLink;
